import UsersSatisfaction from './UsersSatisfaction';

export default UsersSatisfaction;
